import axios from "axios";


let api = axios.create({
  headers: {
    "Client-ID": "yzp1yc0dtlrgmu1hlm110u5c1wn9ll",
    Authorization: `Bearer ${process.env.REACT_APP_TWITCH_BEARER}`,
  },
});

export default api;
